// extracted by mini-css-extract-plugin
export default {"createBookButton":"createBook_createBookButton__4ZVKm"};